import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  taxrate: PropTypes.any,
  taxrates: PropTypes.any,
  onSave: PropTypes.func,
};

class ViewTaxrate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let taxrate = nextProps.taxrate;
    if (taxrate.zipcode) {
      taxrate = nextProps.taxrate;
    } else {
      taxrate = nextProps.taxrates.results[0];
    }
    taxrate.zipcode = (taxrate.zipcode === null) ? '00000' : taxrate.zipcode;
    this.setState({ taxrate });
  }
  navigateToEdit() {
    browserHistory.push(`/taxrate/${this.props.taxrate.zipcode}`);
  }
  handleCancel() {
    browserHistory.push('/taxrate');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="Zipcode"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.taxrate.zipcode}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.taxrate.name}
            name="name"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Tax Rate"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.taxrate.tax}
            name="tax"
            style={styles.inputStyle}
          />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

ViewTaxrate.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewTaxrate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    taxrate: state.taxrates.taxrate,
    taxrates: state.taxrates,
  };
}

export default connect(mapStateToProps)(ViewTaxrate);



// WEBPACK FOOTER //
// ./src/components/taxrate/ViewTaxrate.js